import Login from "components/pages/Login"
import { useRedirectLoggedInUsers } from "hooks/misc/useRedirectLoggedInUsers"

export default function LoginPage({ skipRedirect }: { skipRedirect?: boolean }) {
  useRedirectLoggedInUsers(undefined, skipRedirect)
  return <Login />
}
